import { CloseOutlined } from '@mui/icons-material';
import React, { memo, useState } from "react";
import styled from "styled-components";
import { selectLoteriaImg } from "utils/config/reference";

interface Element {
  selected: React.JSX.Element;
  value: string;
  backgroundColor: string;
  percant: number;
  isCustom: boolean;
}

interface MyLoteriaContentProps {
  SelectedTypeComponent: React.ComponentType<{
    currentIndex: number;
    element: Element;
    selectedType: string;
    totalCells: number;
    readOnly: boolean;
    viewType: string;
  }>;
  grid: Element[];
  bingoType: string;
  viewType: string;
  text: string;
  MatchType: string;
}

interface GridContainerProps {
  containerWidth: number;
  minCellWidth: number;
}

const ViewMyLoteriaContent: React.FC<MyLoteriaContentProps> = ({
  MatchType,
  SelectedTypeComponent,
  grid,
  bingoType,
  viewType = "",
  text,
}) => {
  const [isVisible, setIsVisible] = useState(true);

  if (!isVisible) return null;

  const containerWidth = 100;
  const minCellWidth = 150;

  return (
    <>
      <LoteriaContainer>
      <HeadingText>{text}</HeadingText>
      <CloseButton onClick={() => setIsVisible(false)} />
        <GridContainer
          className="grid-container"
          containerWidth={containerWidth}
          minCellWidth={minCellWidth}
        >
          {grid?.map((element, index) => (
            <div className="relative" key={index}>
              <div className="cell-with-coin-container">
                <div
                    style={{
                      width: (MatchType === "Image" || MatchType === "OnlyImage") ? "137px" : "100px",
                      height: (MatchType === "Image" || MatchType === "OnlyImage") ? "137px" : "100px",
                  }}
                >
                      {(element as any)?.selected && (
                          <img
                              src={selectLoteriaImg}
                              alt="Selected"
                              style={{
                                  width: "55px",
                                  height: "55px",
                                  position: "absolute",
                                  top: "5px",
                                  left: "5px"
                              }}
                          />
                       )}
                  </div>
              </div>
              <SelectedTypeComponent
                currentIndex={index}
                element={element}
                selectedType={bingoType}
                totalCells={grid?.length}
                readOnly={true}
                viewType={viewType}
              />
            </div>
          ))}
        </GridContainer>
      </LoteriaContainer>
    </>
  );
};

export default memo(ViewMyLoteriaContent);

const HeadingText = styled.p`
  font-size: 18px;
  text-align: center;
  font-weight: 500;
  margin-bottom: 0px
`;

const GridContainer = styled.div<GridContainerProps>`
  display: grid;
  grid-template-columns: ${({ minCellWidth }) =>
    `repeat(auto-fit, minmax(${minCellWidth}px, 1fr))`};
  width: ${({ containerWidth }) => `${containerWidth}%`};
  border-radius: 4px;
  overflow: hidden;
  gap: 3px;
  height: 100%;
  overflow: auto;
  padding: 7px;
`;

const LoteriaContainer = styled.div`
  position: absolute;
  z-index: 8;
  inset: 0;
  width: 100%;
  top: 123px;
  background: #fff;
  box-shadow: 10px 10px 15px rgba(0, 0, 0, 0.5);
  padding: 7px;
  height: fit-content;
  max-height: 492px;
  border-radius: 8px;
  overflow: auto;
  min-height: 492px;
`;
const CloseButton = styled(CloseOutlined)`
  position: absolute;
  top: 10px;
  right: 10px;
  font-size: 20px;
  cursor: pointer;
  z-index: 10;
  color: red;
`;